module.exports = __webpack_public_path__ + "static/faq-header-bg-f4ce4163babfb1b6a4607ee19a600886.gif";